import React from 'react';
import { Grid } from 'semantic-ui-react';

import OverviewLinkCard from './components/OverviewLinkCard';

const COLUMNS_PER_ROW = 4;

const links = [
  { to: '/exchange', icon: 'exchange', header: 'Exchange' },
  { to: '/integrations', icon: 'internet explorer', header: 'Integrations' },
  { to: '/users', icon: 'users', header: 'Users' },
  { to: '/creatives', icon: 'lightbulb outline', header: 'Creatives' },
  { to: '/cb-exchange', icon: 'exchange', header: 'CBExchange' }
];

const rows = [links.slice(0, COLUMNS_PER_ROW), links.slice(COLUMNS_PER_ROW)];

const Overview = () => (
  <Grid>
    {rows.map(row => (
      <Grid.Row key={row[0].to} columns={COLUMNS_PER_ROW}>
        {row.map(link => (
          <Grid.Column key={link.to}>
            <OverviewLinkCard
              link={link.to}
              icon={link.icon}
              header={link.header}
              isExternalLink={link.isExternalLink}
            />
          </Grid.Column>
        ))}
      </Grid.Row>
    ))}
  </Grid>
);

export default Overview;
